'use client'

import { useEffect } from 'react'

export default function GlobalError({
    error,
    reset,
}: {
    error: Error & { digest?: string }
    reset: () => void
}) {
    useEffect(() => {
        // 에러 로깅
        console.error('Global Error:', error)
    }, [error])

    return (
        <html>
            <body>
                <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
                    <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8">
                        <div className="text-center">
                            <div className="mb-6">
                                <svg
                                    className="mx-auto h-16 w-16 text-red-500"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
                                    />
                                </svg>
                            </div>

                            <h1 className="text-2xl font-bold text-gray-900 mb-4">
                                서버 오류가 발생했습니다
                            </h1>

                            <p className="text-gray-600 mb-6">
                                페이지를 불러오는 중 문제가 발생했습니다.
                                잠시 후 다시 시도해주세요.
                            </p>

                            {error.digest && (
                                <div className="mb-4 p-3 bg-gray-100 rounded text-sm text-gray-700">
                                    <p className="font-medium">오류 ID: {error.digest}</p>
                                </div>
                            )}

                            <div className="space-y-3">
                                <button
                                    onClick={reset}
                                    className="w-full px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                                >
                                    다시 시도
                                </button>

                                <button
                                    onClick={() => window.location.href = '/'}
                                    className="w-full px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors"
                                >
                                    홈으로 이동
                                </button>
                            </div>

                            <div className="mt-6 text-xs text-gray-500">
                                <p>문제가 지속되면 관리자에게 문의해주세요.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </body>
        </html>
    )
} 